<template>
	<div>
		<modal-adicionar-item
			v-if="exibirModaAdicionarItens"
			:exibir="exibirModaAdicionarItens"
			@recarregar-ata-itens-listagem="buscarItensAtaListagem()"
			@fechar-modal="abrirOuFecharModalAdicionar"
		>
		</modal-adicionar-item>

		<modal-confirmacao
			id="excluir"
			:exibir="exibirModalExclusaoItem"
			:mensagem="mensagemExclusaoItem"
			@fechar-modal="abrirOuFecharModalExclusao"
			@confirmar="excluir"
			:subtituloModal="subtituloModalExclusao"
			:tituloModal="tituloModalexclusao"
		></modal-confirmacao>

		<modal-fornecedores-aderentes
			:exibir="exibirModalFornecedoresAderentes"
			@fechar-modal="abrirOuFecharModalFornecedoresAderentes"
			:fornecedores-do-item="fornecedoresDoItem"
		></modal-fornecedores-aderentes>
		<modal-realinhar
			:item-selecionado="itemRealinhamentoSelecionado"
			:exibir="exibirModalRealinhar"
			@fechar-modal="abrirOuFecharModalRealinhar"
			@salvar-realinhar="salvarRealinhar"
		></modal-realinhar>
		<modal-aditar-item
			:exibir="exibirModalAditarItem"
			:item-selecionado="itemAdidamentoSelecionado"
			@fechar-modal="abrirOuFecharModalAditarItem"
			@carregar-listagem="carregarListagem"
		></modal-aditar-item>
		<modal-alterar-fornecedor
			:exibir="exibirModalAlterarFornecedor"
			@fechar-modal="abrirOuFecharModalAlterarFornecedor"
			@carregar-listagem-item="carregarListagem"
		></modal-alterar-fornecedor>
		<modal-gerenciar-estoque
			:exibir="exibirModalGerenciarEstoque"
			@fechar-modal="abrirOuFecharModalGerenciarEstoque"
			@carregar-listagem-item="carregarListagem"
		></modal-gerenciar-estoque>
		<modal-alterar-classificacao
			:exibir="exibirModalAlterarClassificacao"
			@fechar-modal="abrirOuFecharModalAlterarClassificacao"
			@carregar-listagem-item="carregarListagem"
		></modal-alterar-classificacao>
		<modal-bloquear
			:item-selecionado="itemParaBloquear"
			:exibir="exibirModalBloqueio"
			@fechar-modal="abrirOuFecharModalBloqueio"
			@carregar-listagem-item="carregarListagem"
		></modal-bloquear>
		<modal-historico-aditivo-apostila
			v-if="exibirModalHistoricoAditivoApostila"
			:exibir="exibirModalHistoricoAditivoApostila"
			@fechar-modal="abrirOuFecharModalHistoricoAditivoApostila"
			titulo-modal="Histórico Aditivo/Apostila"
			:id-ata="$route.params.id"
		>
		</modal-historico-aditivo-apostila>
		<modal-prazo-entrega
			v-if="exibirModalPrazoEntrega"
			:exibir="exibirModalPrazoEntrega"
			@fechar-modal="fecharModalPrazoEntrega"
		></modal-prazo-entrega>
		<modal-upload
			v-if="exibirModalImportarConsumo"
			exibir-tooltip-informativo
			exibir-campo-modelo
			:exibir="exibirModalImportarConsumo"
			:exibir-mensagem-aviso="exibirMensagemAvisoOrgaoImportadoPlanilha"
			mensagem-aviso="A planilha do órgão já foi importada"
			:extensoes-permitidas="extensoesPermitidasImportarConsumo"
			mensagem-tooltip-informativo="Você só pode adicionar 1 arquivo com a extensão: .xlsx"
			titulo="Importar Consumo"
			:url-arquivos-modelo="extensoesPermitidasImportarConsumo"
			:arquivos-modelos-estaticos="false"
			:id-pasta-externa-digital="informacoesAta.idPastaExternaDigital"
			:repositorio-flowbee="informacoesAta.repositorioFlowbee"
			@fechar-modal="abrirOuFecharModalImportarConsumo"
			@salvar="importarPlanilha"
			@arquivo-enviado="tratarEventoArquivoEnviado"
			@baixar-modelo="tratarEventoBaixarModelo"
			@apagar-anexo="apagarAnexo()"
		></modal-upload>

		<div class="arp-botoes-listagem-itens-ata">
			<v-row>
				<v-col cols="12" sm="3" class="flex-column flex-sm-row d-flex justify-sm-start">
					<botao-primario
						v-if="temPermissaoEdicao && !isAtaAdesao && !isAtaCancelada"
						nome-botao="Adicionar"
						icone="add_circle"
						class="botao-tamanho-arp mr-2"
						v-az-auth="permissoes.itemAtaComProcessoCriar"
						:block="$vuetify.breakpoint.smAndDown"
						@click="abrirOuFecharModalAdicionar"
					></botao-primario>
					<acessar-ata-itens-btn-historico
						v-if="podeMostrarBotaoHistorico()"
						@mudar-ata="atualizarPaginaParaPegarInformacoesDaAtaDoBtnHistorico"
					></acessar-ata-itens-btn-historico>
					<acessar-ata-itens-btn-mais-acoes
						v-if="temPermissaoEdicao && !isAtaCancelada"
						:block="$vuetify.breakpoint.smAndDown"
						@excluir-itens="excluirItensEmMassa"
						@bloquear-itens="bloquearItensEmMassa"
						@prazo-entrega="alterarPrazoEntregaEmMassa"
					></acessar-ata-itens-btn-mais-acoes>
					<acessar-ata-itens-btn-aditivo-apostila
						v-if="exibirBotaoAditivoApostila && !isAtaAdesao"
						:block="$vuetify.breakpoint.smAndDown"
						:is-ata-efetivada="estaEfetivado(informacoesAta.situacao)"
						@criar-aditivo-apostila="acessarAditivoApostila"
						@historico-aditivo-apostila="abrirOuFecharModalHistoricoAditivoApostila"
					></acessar-ata-itens-btn-aditivo-apostila>
					<botao-baixar-importar-prev-consumo
						v-if="
							isIntegracaoWeblicAtivo &&
							!isAtaAdesao &&
							!ehHistoricoProrrogacao(informacoesAta) &&
							ataPermiteImportacaoPlanilha &&
							!isAtaCancelada
						"
						class="botao-baixar-importar mr-5"
						@importar-modelo="abrirOuFecharModalImportarConsumo"
						@atualizar-ata="carregarInformacoesDaAta"
					></botao-baixar-importar-prev-consumo>
				</v-col>
			</v-row>
		</div>
		<acessar-ata-itens-listagem
			ref="acessar-ata-itens-listagem"
			:total-paginas="listagem.totalPaginas"
			:total-itens="listagem.totalItens"
			:paginacao="listagem.paginacao"
			:itens-ata="listagem.datasource"
			:informacoes-ata="informacoesAta"
			@aditar-item="modalAditarItemIndividual"
			@alterar-classificacao="abrirModalAlteracaoClassificacao"
			@alterar-fornecedor="abrirModalAlterarFornecedor"
			@paginar="paginarAtaItensListagem"
			@resetar-page="resetarPaginaItemAtaListagem"
			@vizualizar-fornecedores="buscarFornecedoresDoItem"
			@gerenciar-estoque="abrirModalGerenciarEstoque"
			@excluir-item="abrirModalConfirmacaoExclusao"
			@realinhar="abrirModalRealinhar"
			@bloquear="abrirModalBloqueio"
		></acessar-ata-itens-listagem>
	</div>
</template>
<script>
import AcessarAtaItensListagem from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/AcessarAtaItensListagem.vue'
import { actionTypes, permissoes, routesNames } from '@/core/constants'
import AcessarAtaItensBtnMaisAcoes from '@/views/pages/ata/acessar/gestao-da-ata/itens/botoes/AcessarAtaItensBtnMaisAcoes.vue'
import mutationTypes from '@/core/constants/mutation-types'
import ModalAdicionarItem from '@/views/pages/ata/acessar/gestao-da-ata/itens/adicionar/ModalAdicionarItem'
import ModalFornecedoresAderentes from '@/views/pages/ata/acessar/gestao-da-ata/itens/modal-fornecedores-aderentes/ModalFornecedoresAderentes'
import ModalConfirmacao from '@/views/components/ModalConfirmacao'
import ModalBloquear from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/bloqueio/ModalBloqueio.vue'
import { mapState } from 'vuex'
import ModalRealinhar from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/realinhar/ModalRealinhar.vue'
import ModalAlterarFornecedor from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/alteracao-fornecedor/ModalAlterarFornecedor.vue'
import ModalAlterarClassificacao from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/alteracao-classificacao/ModalAlterarClassificacao.vue'
import ModalAditarItem from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/aditamento/ModalAditarItem'
import ModalGerenciarEstoque from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/gerenciar-estoque/ModalGerenciarEstoque.vue'
import validacaoAta from '@/views/mixins/validacaoAta'
import AcessarAtaItensBtnHistorico from '@/views/pages/ata/acessar/gestao-da-ata/itens/botoes/AcessarAtaItensBtnHistorico.vue'
import RoutesNames from '@/core/constants/routes-names'
import AcessarAtaItensBtnAditivoApostila from '@/views/pages/ata/acessar/gestao-da-ata/itens/botoes/AcessarAtaItensBtnAditivoApostila.vue'
import ModalHistoricoAditivoApostila from '@/views/components/ModalHistoricoAditivoApostila.vue'
import ModalPrazoEntrega from '@/views/pages/ata/acessar/gestao-da-ata/itens/modal-prazo-entrega/ModalPrazoEntrega'
import BotaoBaixarImportarPrevConsumo from '@/views/pages/ata/acessar/gestao-da-ata/itens/botoes/botao-baixar-importar-prev-consumo/BotaoBaixarImportarPrevConsumo'
import ExtensoesArquivos from '@/core/constants/extensoes-arquivos'

export default {
	name: 'acessar-ata-itens-view',
	components: {
		BotaoBaixarImportarPrevConsumo,
		ModalPrazoEntrega,
		ModalHistoricoAditivoApostila,
		AcessarAtaItensBtnHistorico,
		ModalGerenciarEstoque,
		ModalAlterarClassificacao,
		ModalAlterarFornecedor,
		ModalAditarItem,
		ModalBloquear,
		AcessarAtaItensBtnMaisAcoes,
		AcessarAtaItensListagem,
		ModalAdicionarItem,
		ModalFornecedoresAderentes,
		ModalRealinhar,
		ModalConfirmacao,
		AcessarAtaItensBtnAditivoApostila,
	},
	mixins: [validacaoAta],
	inject: ['idAta'],
	data() {
		return {
			listagem: this.initializeAcessarAtaItensListagem(),
			exibirModaAdicionarItens: false,
			exibirModalAlterarFornecedor: false,
			exibirModalGerenciarEstoque: false,
			exibirModalExclusaoItem: false,
			exibirModalFornecedoresAderentes: false,
			exibirModalBloqueio: false,
			exibirModalRealinhar: false,
			exibirModalAditarItem: false,
			exibirModalAlterarClassificacao: false,
			exibirModalHistoricoAditivoApostila: false,
			exibirModalPrazoEntrega: false,
			itemParaExcluir: null,
			itemParaBloquear: null,
			exibirModalImportarConsumo: false,
			extensoesPermitidasImportarConsumo: [ExtensoesArquivos.XLSX.text],
			idArquivoTemporarioConsumo: null,
			itemRealinhamentoSelecionado: {},
			itemAdidamentoSelecionado: {},
			fornecedoresDoItem: null,
			mensagemExclusaoItem: 'O item excluído não poderá ser recuperado!',
			subtituloModalExclusao: 'Deseja realmente excluir?',
			tituloModalexclusao: 'Excluir',
			permissoesAVerificar: [],
			permissoesNoOrgaoGerenciador: {},
			exibirBotaoAditivoApostila: false,
			exibirMensagemAvisoOrgaoImportadoPlanilha: false,
		}
	},
	computed: {
		...mapState({
			itens: (state) => state.itemAta.itensAtaSelecionados,
			itemSelecionado: (state) => state.itemAta.itemSelecionado,
			informacoesAta: (state) => state.ata.informacoesAta,
			isIntegracaoWeblicAtivo: (state) => state.parametrosSistema.isIntegracaoWeblicAtivo,
		}),
		ataPermiteImportacaoPlanilha() {
			return this.informacoesAta.isPermiteImportacaoPlanilha
		},
		isAtaCancelada() {
			return this.estaCancelada(this.informacoesAta.situacao)
		},
	},
	async created() {
		if (!this.informacoesAta.id) await this.carregarInformacoesDaAta()
		await this.carregarListagem()
		await this.verificarPermissoesNoOrgaoGerenciador()
	},
	methods: {
		initializeAcessarAtaItensListagem() {
			return {
				totalPaginas: 0,
				totalItens: 0,
				filtro: this.$store.state.itemAta.filtro,
				paginacao: this.$store.state.itemAta.paginacao,
				datasource: [],
			}
		},
		abrirOuFecharModalImportarConsumo() {
			this.exibirModalImportarConsumo = !this.exibirModalImportarConsumo
			this.exibirMensagemAvisoOrgaoImportadoPlanilha = false
		},
		async importarPlanilha() {
			await this.$store
				.dispatch(actionTypes.ATA.IMPORTAR_CONSUMO, {
					idAta: this.informacoesAta.id,
					idArquivoTemporario: this.idArquivoTemporarioConsumo,
				})
				.then(() => {
					this.mostrarNotificacaoSucesso(
						'Importação em andamento. Você será notificado quando ela for concluída.',
					)
					this.abrirOuFecharModalImportarConsumo()
				})
		},
		async tratarEventoArquivoEnviado({ id }) {
			this.idArquivoTemporarioConsumo = id
			const { existePlanilhaImportada } = await this.$store.dispatch(
				actionTypes.ATA.VERIFICAR_PLANILHA_IMPORTADA_PARA_ORGAO,
				{
					idAta: this.informacoesAta.id,
					idPlanilhaImportacao: id,
				},
			)

			this.exibirMensagemAvisoOrgaoImportadoPlanilha = !!existePlanilhaImportada
		},
		async tratarEventoBaixarModelo() {
			await this.$store.dispatch(actionTypes.ATA.BAIXAR_MODELO_IMPORTAR_PREV_CONSUMO, this.informacoesAta.id)
		},
		async buscarItensAtaListagem() {
			this.$store.commit(mutationTypes.ITEM_ATA.ITEM_ATA_SELECIONADO, [])
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.BUSCAR_ITENS_ATA_LISTAGEM,
			)

			this.listagem.datasource = this.formatarItens(itens)
			this.listagem.totalItens = totalElements
			this.listagem.totalPaginas = totalPages
		},
		formatarItens(itens) {
			return itens.map((item) => {
				item['_dias'] = item.dias
				item['_tipoDias'] = item.tipoDias
				return item
			})
		},
		async paginarAtaItensListagem(paginacao) {
			this.setPaginacaoItensAtaListagem(paginacao)
			await this.buscarItensAtaListagem()
		},
		async carregarListagem() {
			this.resetarSelecaoDosItensDaListagem()
			await this.setFiltroItensAtaListagem()
			await this.buscarItensAtaListagem()
		},

		resetarSelecaoDosItensDaListagem() {
			this.$store.commit(mutationTypes.ITEM_ATA.UNSET_IS_SELECIONOU_TODOS_ITENS)
		},

		setPaginacaoItensAtaListagem(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.SET_PAGINACAO_LISTAGEM, paginacao)
		},

		setFiltroItensAtaListagem() {
			this.listagem.filtro.idAta = this.idAta
			this.$store.commit(mutationTypes.ITEM_ATA.SET_FILTRO_LISTAGEM, this.listagem.filtro)
		},

		resetarPaginaItemAtaListagem() {
			this.$store.commit(mutationTypes.ITEM_ATA.RESETAR_PAGINA_LISTAGEM)
		},

		async excluirItensEmMassa() {
			if (this.itens.length === 0) {
				this.mostrarNotificacaoErro('Não possui itens para exclusão!')
			} else {
				this.itemParaExcluir = this.itens
				this.abrirOuFecharModalExclusao()
			}
		},
		async abrirModalConfirmacaoExclusao(item) {
			this.itemParaExcluir = [item]
			this.abrirOuFecharModalExclusao()
		},
		async abrirModalRealinhar(item) {
			this.itemRealinhamentoSelecionado = item
			this.abrirOuFecharModalRealinhar()
		},
		async abrirModalAlterarFornecedor(item) {
			this.$store.commit(mutationTypes.ITEM_ATA.SET_ITEM_SELECIONADO, item)

			this.abrirOuFecharModalAlterarFornecedor()
		},
		async abrirModalGerenciarEstoque(item) {
			this.$store.commit(mutationTypes.ITEM_ATA.SET_ITEM_SELECIONADO, item)

			this.abrirOuFecharModalGerenciarEstoque()
		},
		async salvarRealinhar(formIsValid) {
			if (formIsValid) {
				await this.$store.dispatch(actionTypes.ITEM_ATA.REALINHAMENTO.REALINHAR.INSERIR_REALINHAR_ATA)
				this.mostrarNotificacaoSucessoDefault()
				await this.carregarListagem()
				this.abrirOuFecharModalRealinhar()
			}
		},

		async excluir() {
			this.$store.commit(mutationTypes.ITEM_ATA.ITEM_PARA_EXCLUIR, this.itemParaExcluir)
			this.abrirOuFecharModalExclusao()
			await this.$store.dispatch(actionTypes.ITEM_ATA.EXCLUIR)
			await this.carregarListagem()
			this.mostrarNotificacaoSucesso('Item da Ata foi excluído com sucesso!')
			if (this.listagem.datasource.length === 0) this.resetarPaginaItemAtaListagem()
		},

		abrirOuFecharModalAdicionar() {
			this.exibirModaAdicionarItens = !this.exibirModaAdicionarItens
		},

		async buscarFornecedoresDoItem() {
			this.fornecedoresDoItem = await this.$store.dispatch(
				actionTypes.FORNECEDOR_ITEM_ATA.BUSCAR_FORNECEDOR_PRINCIPAL_COM_ADERENTES,
			)

			this.exibirModalFornecedoresAderentes = true
		},

		abrirOuFecharModalFornecedoresAderentes() {
			this.exibirModalFornecedoresAderentes = !this.exibirModalFornecedoresAderentes
		},

		modalAditarItemIndividual(item) {
			this.$store.commit(mutationTypes.ITEM_ATA.ITEM_ATA_SELECIONADO, [item])
			this.itemAdidamentoSelecionado = item
			this.abrirOuFecharModalAditarItem()
		},
		abrirModalAlteracaoClassificacao(item) {
			this.$store.commit(mutationTypes.ITEM_ATA.SET_ITEM_SELECIONADO, item)
			this.abrirOuFecharModalAlterarClassificacao()
		},
		async abrirOuFecharModalAditarItem() {
			this.exibirModalAditarItem = !this.exibirModalAditarItem
		},

		abrirOuFecharModalAlterarFornecedor() {
			this.exibirModalAlterarFornecedor = !this.exibirModalAlterarFornecedor
		},
		abrirOuFecharModalGerenciarEstoque() {
			this.exibirModalGerenciarEstoque = !this.exibirModalGerenciarEstoque
		},
		abrirOuFecharModalAlterarClassificacao() {
			this.exibirModalAlterarClassificacao = !this.exibirModalAlterarClassificacao
		},
		abrirOuFecharModalExclusao() {
			this.exibirModalExclusaoItem = !this.exibirModalExclusaoItem

			if (!this.exibirModalExclusaoItem) {
				this.itemParaExcluir = null
			}
		},
		abrirOuFecharModalRealinhar() {
			this.exibirModalRealinhar = !this.exibirModalRealinhar
		},
		bloquearItensEmMassa() {
			this.itemParaBloquear = null

			if (this.itens.length === 0 || this.itens.filter((obj) => !obj.isBloqueado).length === 0) {
				this.mostrarNotificacaoErro('Não foi selecionado nenhum item para bloquear!')
			} else {
				this.abrirOuFecharModalBloqueio()
			}
		},
		async abrirModalBloqueio(item) {
			this.itemParaBloquear = item
			this.abrirOuFecharModalBloqueio()
		},
		abrirOuFecharModalBloqueio() {
			this.exibirModalBloqueio = !this.exibirModalBloqueio
		},
		async atualizarPaginaParaPegarInformacoesDaAtaDoBtnHistorico(idAta) {
			await this.$router.push({
				name: RoutesNames.ATA.ATA_ACESSAR_ITENS_VIEW,
				params: { id: idAta },
			})
			location.reload()
		},
		podeMostrarBotaoHistorico() {
			return this.informacoesAta.isAtaProrrogada && this.$store.state.parametrosSistema.retornaSaldoAta
		},
		setIdOrgaoParaVerificacaoPermissionamento() {
			const idOrgao = this.informacoesAta.unidadeOrganizacional.id
			this.$store.commit(mutationTypes.PERMISSIONAMENTO.SET_ID_ORGAO_PERMISSIONAMENTO, idOrgao)
		},
		setPermissoesParaVerificacaoPermissionamento() {
			const { aditivoApostilaCriar, aditivoApostilaEditar, aditivoApostilaHistorico } = permissoes

			this.permissoesAVerificar = [aditivoApostilaCriar, aditivoApostilaEditar, aditivoApostilaHistorico]

			this.$store.commit(
				mutationTypes.PERMISSIONAMENTO.SET_PERMISSOES_PERMISSIONAMENTO,
				this.permissoesAVerificar,
			)
		},
		async requisitarVerificacaoDePermissao() {
			const retornoPermissionamento = await this.$store.dispatch(
				actionTypes.PERMISSIONAMENTO.VERIFICAR_PERMISSOES_DO_USUARIO_NO_ORGAO,
			)

			this.permissoesAVerificar.forEach((permissaoAVerificar) => {
				this.permissoesNoOrgaoGerenciador[permissaoAVerificar] = retornoPermissionamento[permissaoAVerificar]
			})
		},
		async verificarPermissoesNoOrgaoGerenciador() {
			if (this.informacoesAta.unidadeOrganizacional) {
				this.setIdOrgaoParaVerificacaoPermissionamento()
				this.setPermissoesParaVerificacaoPermissionamento()
				await this.requisitarVerificacaoDePermissao()
				this.exibirBotaoAditivoApostila = this.podeMostrarBotaoAditivoApostila()
			}
		},
		async carregarInformacoesDaAta() {
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.idAta)
		},
		podeMostrarBotaoAditivoApostila() {
			const permissoesNecessarias = [
				permissoes.aditivoApostilaCriar,
				permissoes.aditivoApostilaEditar,
				permissoes.aditivoApostilaHistorico,
			]

			const possuiPermissaoNecessaria = permissoesNecessarias.some((permissaoAVerificar) => {
				return this.permissoesNoOrgaoGerenciador[permissaoAVerificar] === true
			})

			const possuiSituacaoAtaNecessaria = this.estaEfetivado(this.informacoesAta.situacao) || this.isAtaCancelada

			return (this.informacoesAta.isAtaProrrogada || possuiSituacaoAtaNecessaria) && possuiPermissaoNecessaria
		},
		async acessarAditivoApostila() {
			const body = {
				idAta: this.idAta,
				idsItensAta: this.itens.map((item) => item.id),
			}

			const { id } = await this.$store.dispatch(actionTypes.ADITIVO_APOSTILA.CRIAR_ADITIVO_APOSTILA, body)

			await this.$router.push({
				name: routesNames.ATA.ATA_ACESSAR_ADITIVO_APOSTILA_VIEW,
				params: { id: this.idAta, idAditivoApostila: id },
			})
		},
		abrirOuFecharModalHistoricoAditivoApostila() {
			this.exibirModalHistoricoAditivoApostila = !this.exibirModalHistoricoAditivoApostila
		},
		alterarPrazoEntregaEmMassa() {
			if (this.itens.length === 0) {
				this.mostrarNotificacaoErro('Não foi selecionado nenhum item para atualizar o prazo de entrega!')
			} else {
				this.exibirModalPrazoEntrega = true
			}
		},
		fecharModalPrazoEntrega(alterouPrazoEntrega) {
			this.exibirModalPrazoEntrega = false
			if (alterouPrazoEntrega) this.buscarItensAtaListagem()
		},
		apagarAnexo() {
			this.exibirMensagemAvisoOrgaoImportadoPlanilha = false
		},
	},
}
</script>
<style lang="stylus" scoped>
.arp-botoes-listagem-itens-ata
	display flex;
	margin 25px 0

	> div
		margin-right 15px

.d-flex
	gap: 10px;
</style>
